import type { AskAIResponse } from '../types'
import { WIDGET_CONFIG } from '../config'

interface AnswerViewProps {
  response: AskAIResponse
}

export function AnswerView({ response }: AnswerViewProps) {
  return (
    <div class="spotlight-answer-view">
      <div class="spotlight-answer-icon">{WIDGET_CONFIG.copy.answerIcon}</div>
      <div class="spotlight-answer-text">{response.answer}</div>
      {response.citations.length > 0 && (
        <div class="spotlight-answer-citations">
          <div class="spotlight-answer-citations-label">{WIDGET_CONFIG.copy.sourcesLabel}</div>
          {response.citations.map((c, i) => (
            <a
              key={i}
              class="spotlight-answer-citation"
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {c.title || c.url}
            </a>
          ))}
        </div>
      )}
    </div>
  )
}
